import React, { FC } from 'react';
import Button from '@mui/material/Button';
import { FaqEditorProps } from 'types/assist/faqEditor';
import { FaqEditorItem } from './FaqEditorItem';

export const FaqEditor: FC<FaqEditorProps> = ({
  items,
  onChange,
  readOnlyQuestions = [],
  allowReadOnlyRemoval = false,
  readOnlyQuestionLabel = 'Default FAQ',
  readOnlyQuestionHelperText = 'This is a default Cents FAQ. The question cannot be edited; only the answer can be changed.',
}) => {
  const readOnlyQuestionSet = new Set(readOnlyQuestions);
  const faqItems = items.map((faq, faqIndex) => {
    const isQuestionReadOnly = readOnlyQuestionSet.has(faq.question);
    const isRemovalAllowed = !isQuestionReadOnly || allowReadOnlyRemoval;

    return (
      <FaqEditorItem
        key={faqIndex}
        faq={faq}
        faqIndex={faqIndex}
        items={items}
        isQuestionReadOnly={isQuestionReadOnly}
        isRemovalAllowed={isRemovalAllowed}
        readOnlyQuestionLabel={readOnlyQuestionLabel}
        readOnlyQuestionHelperText={readOnlyQuestionHelperText}
        onChange={onChange}
      />
    );
  });

  const handleAddFaq = () => {
    onChange([...items, { question: '', answer: '' }]);
  };

  return (
    <div>
      {faqItems}
      <Button size="small" onClick={handleAddFaq}>
        + FAQ
      </Button>
    </div>
  );
};
